import React, { FC, ReactNode } from 'react';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import MuiSnackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';

import { SnackbarProcess } from './SnackbarProgress';

interface Props {
  open: boolean;
  message: string;
  onClose: () => void;
  action?: ReactNode;
  duration?: number;
  variant?: 'success' | 'info' | 'warning' | 'error';
}

export const Snackbar: FC<Props> = ({ open, message, duration = 2000, action, variant, onClose }) => {
  if (!open) {
    return null;
  }

  const handleClose = (_: React.SyntheticEvent<any> | Event, reason: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose();
  };

  return (
    <MuiSnackbar
      sx={{ background: 'background.paper' }}
      ContentProps={{ sx: { width: '360px' } }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      onClose={handleClose}
      autoHideDuration={duration + 500}
      TransitionComponent={(slideProps) => <Slide {...slideProps} direction="up" />}
    >
      <Alert
        action={action}
        onClose={onClose}
        icon={variant ? undefined : false}
        color={variant}
        sx={!variant ? { position: 'relative', color: 'text.primary', backgroundColor: 'background.paper' } : undefined}
      >
        {open && <SnackbarProcess variant={variant} duration={duration} onClose={onClose} />}
        {message}
      </Alert>
    </MuiSnackbar>
  );
};
